import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => {
  return {
    inputBase: {
      flex: 1,
      fontSize: '18px',
      fontWeight: 'bold',
      paddingLeft: '20px'
    },
    fileSelectionArea: {
      cursor: 'pointer',
      padding: '50px',
      marginBottom: '10px',
      border: '2px dotted #D3D3D3'
    },
    filesList: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    filesListItem: {
      width: '48%',
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #CCC',
      borderRadius: '10px',
      margin: '5px',
      position: 'relative'
    },
    filesListItemPreviewImage: {
      width: '60px',
      height: '60px',
      margin: '10px'
    },
    filesListItemPreviewExtension: {
      width: '60px',
      height: '60px',
      color: '#FFF',
      backgroundColor: '#D3D3D3',
      fontSize: '16px',
      display: 'grid',
      placeItems: 'center',
      margin: '10px'
    },
    filesListItemContentItem: {
      maxWidth: '100px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    filesListItemContentItem1: {
      fontSize: '12px',
    },
    filesListItemContentItem2: {
      fontSize: '10px',
      color: '#666'
    },
    filesListItemRemove: {
      position: 'absolute',
      top: '25%',
      right: 0
    },
    uploadingBugReportLoader: {
      width: '100%',
      height: '400px',
      display: 'grid',
      placeItems: 'center'
    }
  };
});

export default styles;
